// Kanal marketplace aktif (Shopee / Tokopedia). Komponen Shopee dipakai ulang; backend memisahkan data lewat header X-Channel.
import axios from "axios";
import { useEffect, useState, useSyncExternalStore } from "react";
import { MarketplaceBrand } from "./marketplace_brand";
import "./tokopedia.css";

let current = "shopee";
const subs = new Set();
const stash = {};
const apply = () => { if (typeof document !== "undefined") document.documentElement.dataset.channel = current; };
if (typeof document !== "undefined") {  // ikon resmi untuk CSS kartu (::before) — path publik tidak diproses webpack
  const pub = process.env.PUBLIC_URL || "", st = document.documentElement.style;
  st.setProperty("--brand-shopee-ico", `url("${pub}/brand/shopee-bag.png")`);
  st.setProperty("--brand-tokopedia-ico", `url("${pub}/brand/tokopedia-icon.png")`);
}
apply();

export const getChannel = () => current;
export function setChannel(ch) {
  const next = ch === "tokopedia" ? "tokopedia" : "shopee";
  if (next === current) return;
  current = next; apply(); subs.forEach(f => f());
}
axios.interceptors.request.use((cfg) => {
  if (cfg.headers?.set) cfg.headers.set("X-Channel", current, false);
  else cfg.headers = { "X-Channel": current, ...(cfg.headers || {}) };
  return cfg;
});

export function useChannel() {
  return useSyncExternalStore((cb) => { subs.add(cb); return () => subs.delete(cb); }, getChannel, getChannel);
}

// Pilih tab sumber: tokopedia = komponen Shopee dengan kanal Tokopedia. Ganti kanal me-remount area (key) → pilihan disimpan sementara.
export function pickSource(name, value, setter) {
  const ch = value === "tokopedia" ? "tokopedia" : "shopee";
  const src = value === "tokopedia" ? "shopee" : value;
  if (ch !== current) { stash[name] = src; setChannel(ch); } else setter(src);
}
export function initSource(name, def) {
  if (name in stash) { const v = stash[name]; delete stash[name]; return v; }
  return current === "tokopedia" ? "shopee" : def;
}
export function stashFor(name, value) { stash[name] = value; }
export function takeStash(name, def) { if (name in stash) { const v = stash[name]; delete stash[name]; return v; } return def; }
export const tabOf = (src) => (src === "shopee" && current === "tokopedia" ? "tokopedia" : src);
export function useChannelReset() { useEffect(() => () => setChannel("shopee"), []); }

// Halaman pemantauan Owner: aktifkan kanal yang dituju (mis. dari Pusat Kendali), kembali ke Shopee saat ditinggalkan.
export function ChannelScope({ ch }) {
  useEffect(() => { setChannel(ch); return () => setChannel("shopee"); }, [ch]);
  return <TokopediaBanner/>;
}

export function TokopediaBanner() {
  const ch = useChannel();
  if (ch !== "tokopedia") return null;
  return <div className="tkp-banner" role="status" data-testid="tokopedia-banner"><b className="tkp-banner-logo"><MarketplaceBrand channel="tokopedia" size="sm"/></b><span>Antrean khusus pesanan Tokopedia — terpisah dari Shopee.</span></div>;
}

export function ChannelTag() {
  return useChannel() === "tokopedia" ? <span className="tkp-tag" data-testid="channel-tag-tokopedia" title="Tokopedia"><MarketplaceBrand channel="tokopedia" size="xs"/></span> : null;
}

// Lampiran referensi Tokopedia (Object Storage, data lampiran yang sudah ada) — tampil di kartu pekerjaan kanal Tokopedia.
const attCache = {};
const ATT_API = `${process.env.REACT_APP_BACKEND_URL}/api/tokopedia`;
export function TokopediaAttachments({ orderNumber }) {
  const ch = useChannel();
  const [atts, setAtts] = useState(attCache[orderNumber] || null);
  useEffect(() => {
    if (ch !== "tokopedia" || !orderNumber || attCache[orderNumber]) return;
    let alive = true;
    attCache[orderNumber] = axios.get(`${ATT_API}/attachments-by-order/${encodeURIComponent(orderNumber)}`, { withCredentials: true })
      .then(r => r.data.attachments || []).catch(() => { delete attCache[orderNumber]; return []; });
    attCache[orderNumber].then(a => alive && setAtts(a));
    return () => { alive = false; };
  }, [ch, orderNumber]);
  useEffect(() => { if (attCache[orderNumber]?.then) attCache[orderNumber].then(setAtts); }, [orderNumber]);
  const list = Array.isArray(atts) ? atts : [];
  if (ch !== "tokopedia" || !list.length) return null;
  return <span className="tkp-atts" data-testid={`tkp-atts-${orderNumber}`} onClick={e => e.stopPropagation()}>
    <span className="tkp-atts-l">Lampiran ({list.length})</span>
    {list.map(a => <a key={a.id} href={`${ATT_API}/attachments/${a.id}`} target="_blank" rel="noopener noreferrer" title={a.filename}
      className="tkp-att-thumb" data-testid={`tkp-att-open-${a.id}`}>
      {String(a.content_type).startsWith("image/") ? <img src={`${ATT_API}/attachments/${a.id}`} alt={a.filename} loading="lazy"/> : <b>PDF</b>}
    </a>)}
  </span>;
}

// Scan lintas kanal: backend menolak (409 channel_mismatch) tanpa tindakan; operator diarahkan ke tab kanal yang benar.
const pendingScan = {};
export const channelMismatch = (e) => { const d = e?.response?.data?.detail; return e?.response?.status === 409 && d?.code === "channel_mismatch" ? d : null; };
export function openChannelFor(names, ch, kind, code, extra = {}) {
  names.forEach(n => { stash[n] = "shopee"; });
  Object.assign(stash, extra);
  pendingScan[kind] = code;
  setChannel(ch);
}
export function takePendingScan(kind) { const c = pendingScan[kind]; delete pendingScan[kind]; return c || ""; }
export function ChannelMismatchNotice({ m, onOpen, testid }) {
  const lbl = String(m.channel).toUpperCase();
  return <div className="tkp-mismatch" role="alert" data-testid={testid}>
    <b>{m.message}</b>
    <button type="button" className="tkp-main" onClick={onOpen} data-testid={`${testid}-open`}>Buka di tab {lbl}</button>
  </div>;
}
